import pages from "../pages/index";

const routes = [
  {
    path: "/login",
    element: pages.Login,
  },
  {
    path: "/forgotPassword",
    element: pages.ForgotPassword,
  },
  {
    path: "/setPassword/:id",
    element: pages.ResetPassword,
  },
  // {
  //   path: "/pos/online",
  //   element: pages.PosOnline,
  // },
  {
    path: "/pos/online/:companyId",
    element: pages.PosOnline,
  },
  {
    path: "/pos/online/status",
    element: pages.PosStatus,
  },
];

export default routes;
